import React from 'react';
import { Check, X } from 'lucide-react';
export function Comparison() {
  const rows = [{
    bad: 'Videos sin orden ni sistema',
    good: 'Progresión clara de 0 a tu primera canción'
  }, {
    bad: 'Acordes que no armás en canciones',
    good: 'Método paso a paso, tomo por tomo'
  }, {
    bad: 'Te duelen los dedos y no sabés por qué',
    good: 'Técnica y digitación explicadas desde cero'
  }, {
    bad: 'Nunca terminás una canción completa',
    good: '15+ canciones fáciles incluidas'
  }, {
    bad: 'Aprendés, olvidás, repetís el ciclo',
    good: 'Plan de práctica diaria de 30 días'
  }];
  return <section className="w-full bg-white text-fondo-principal py-section px-4" data-id="element-43">
      <h2 className="text-xl font-bold text-center mb-8" data-id="element-44">
        Sin Guitarra Fácil PRO{' '}
        <span className="text-gray-400 font-normal mx-2" data-id="element-45">vs.</span> Con Guitarra
        Fácil PRO
      </h2>

      <div className="flex flex-col gap-4" data-id="element-46">
        {rows.map((row, idx) => <div key={idx} className="flex flex-col gap-2 p-4 rounded-xl border border-gray-100 bg-gray-50" data-id="element-47">
            <div className="flex items-start gap-2 text-sm text-gray-500" data-id="element-48">
              <X className="w-4 h-4 text-red-400 shrink-0 mt-0.5" data-id="element-49" />
              <span data-id="element-50">{row.bad}</span>
            </div>
            <div className="w-full h-px bg-gray-200 my-1" data-id="element-51"></div>
            <div className="flex items-start gap-2 text-sm font-bold text-gray-900" data-id="element-52">
              <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-53" />
              <span data-id="element-54">{row.good}</span>
            </div>
          </div>)}
      </div>
    </section>;
}